// src/kontrolEdge/routes.tsx
import React from "react";
import { Route } from "react-router-dom";
import PortCreationFlow from "./views/PortCreationFlow";
import MainPort from "./components/Port/MainPort";
// import ServicesOverview from "./views/KontrolEdgeMain";
import MainInternet from "./components/Internet/MainInternet";
import MainBackbone from "./components/Backbone/MainBackbone";
import MainCloudConnectivity from "./components/CloudConnectivity/MainCloudConnectivity";
import MainDataCenter from "./components/DataCenter/MainDataCenter";
import PortDetails from "./components/Port/PortDetails/PortDetails";
import HardwareInventoryPage from "./components/ResourceManager/Hardware/HardwareInventoryPage";
import DcInventoryPage from "./components/ResourceManager/DataCenter/DcInventoryPage";
import PortInventoryPage from "./components/ResourceManager/Port/PortInventoryPage";
import LastMileInventoryPage from "./components/ResourceManager/LastMile/LastMileInventoryPage";
import DCConnectionsPage from "./components/ResourceManager/DataCenterConnections/DCConnectionsPage";
import InternetCreationFlow from "./views/InternetCreationFlow";
import IpInventoryPage from "./components/ResourceManager/IpBlock/IpInventoryPage";
import SubnetInventoryPage from "./components/ResourceManager/PublicSubnet/SubnetInventoryPage";
import InternetDetails from "./components/Internet/InternetDetails/InternetDetails";
import ManagerOverview from "./views/ManagerOverview";
import DatacenterDetails from "./components/DataCenter/DataCenterDetails/DatacenterDetails";
import OutagesView from "./views/Outages/OutagesView";
import CloudConnectivityDetails from "./components/CloudConnectivity/CloudDetails.tsx/CloudConnectivityDetails";
import ThirdPartyInventoryPage from "./components/ResourceManager/ThirdParty/ThirdPartyInventoryPage";
import PartnerPage from "./components/ResourceManager/Tenants/Partner/PartnerPage";
import CustomerPage from "./components/ResourceManager/Tenants/Customer/CustomerPage";
import NotificationsPage from "settings/account/components/Notifications/NotificationsPage";
import NotificationsHistory from "settings/account/components/Notifications/NotificationsHistory/NotificationsHistory";
import FwaasPage from "@shared/components/fwaas/FwaasPage";
import QuotationsPage from "@shared/components/quotations/QuotationsPage";


export const kontrolEdgeRoutes = [
    // <Route key="kontrolMain" path="/kontrol" element={<ServicesOverview />} />,
    <Route key="mainDashboard" path="/kontrol" element={<ManagerOverview />} />,
    <Route key="outagesDashboard" path="/kontrol/outages" element={<OutagesView />} />,
    <Route key="addPort" path="/kontrol/add-port" element={<PortCreationFlow />} />,
    <Route key="addInternet" path="/kontrol/add-ipx" element={<InternetCreationFlow />} />,
    <Route key="mainPort" path="/kontrol/port" element={<MainPort />} />,
    <Route key="portDetails" path="/kontrol/port-details" element={<PortDetails />} />,
    <Route key="mainInternet" path="/kontrol/ipx" element={<MainInternet />} />,
    <Route key="internetDetails" path="/kontrol/internet/internet-details" element={<InternetDetails />} />,
    <Route key="mainDataCenter" path="/kontrol/datacenter" element={<MainDataCenter />} />,
    <Route key="mainDataCenter" path="/kontrol/datacenter-details" element={<DatacenterDetails />} />,
    <Route key="mainCloud" path="/kontrol/cloud-connectivity" element={<MainCloudConnectivity />} />,
    <Route key="cloudDetails" path="/kontrol/cloud-connectivity/details" element={<CloudConnectivityDetails />} />,
    <Route key="mainBackbone" path="/kontrol/backbone" element={<MainBackbone />} />,
    <Route key="fwaas" path="/kontrol/fwaas" element={<FwaasPage />} />,
    <Route key="quotations" path="/kontrol/quotations" element={<QuotationsPage />} />,

    <Route
        key="adminCenter"
        path="kontrol/admin-center/data-center"
        element={<DcInventoryPage />}
    />,
    <Route
        key="hardware-inventory"
        path="kontrol/admin-center/hardware"
        element={<HardwareInventoryPage />}
    />,
    <Route
        key="port-inventory"
        path="kontrol/admin-center/port"
        element={<PortInventoryPage />}
    />,
    <Route
        key="lastMile-inventory"
        path="kontrol/admin-center/lastMile"
        element={<LastMileInventoryPage />}
    />,
    <Route
        key="dcConnections-inventory"
        path="kontrol/admin-center/dc-connections"
        element={<DCConnectionsPage />}
    />,
    <Route
        key="ipblock-inventory"
        path="kontrol/admin-center/ip-block"
        element={<IpInventoryPage />}
    />,
    <Route
        key="publicsubnet-inventory"
        path="kontrol/admin-center/public-subnet"
        element={<SubnetInventoryPage />}
    />,
    <Route
        key="thirdparty-inventory"
        path="kontrol/admin-center/third-party"
        element={<ThirdPartyInventoryPage />}
    />,
    <Route
        key="partners"
        path="kontrol/admin-center/partners"
        element={<PartnerPage />}
    />,
    <Route
        key="customers"
        path="kontrol/admin-center/customers"
        element={<CustomerPage />}
    />,
    <Route key="notifications" path="/kontrol/notifications-management" element={<NotificationsPage />} />,
    <Route key="notifications" path="/kontrol/notifications-history" element={<NotificationsHistory/>} />,
    
];
